import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'
import { t } from '@/lib/helpers'
import { getPathParams } from '@/lib/routes'
import { useErrorHandler } from '@/lib/hooks'

import { CookieFormInput } from '../types'
import { TOAST_CONFIG } from '@/lib/constants'
import { COOKIE_CATEGORIES, PROJECT } from '../constants'

type Payload = {
  data: CookieFormInput
  params: {
    project_id: number
    cookie_id: number
  }
}

const updateCookie = async ({ data, params }: Payload) => {
  const { project_id, cookie_id } = params

  const response = await fetchAPI<Cookie>({
    path: `/projects/${project_id}/cookies/${cookie_id}`,
    method: 'put',
    data,
  })

  return response.data
}
export const useUpdateCookie = () => {
  const toast = useToast()
  const handleError = useErrorHandler()
  const queryClient = useQueryClient()

  const { project_id } = getPathParams()
  const params = { project_id: Number(project_id) }

  return useMutation<Cookie, AxiosError, Payload>(updateCookie, {
    onSuccess() {
      queryClient.invalidateQueries([COOKIE_CATEGORIES, params])
      queryClient.invalidateQueries([PROJECT, params])

      toast({
        ...TOAST_CONFIG,
        title: t('views.features.domains.show.manage.services.cookie_updated'),
      })
    },
    onError(error) {
      handleError(error)
    },
  })
}
